<!-- 
COMPONENTE QUE TRATA DA LIBERACAO DE RENTABILIDADE DO PEDIDO
-->

<script>
import { SysVars } from '../main';
import apiPedido from '../api/api-pedido.js'
import { formatDataHoraExtenso } from '../shared/utils'

export default {
    props: {
        pedv: {type: Object}, 
    },

    data () {
        return {
            obs: '',
        }
    },

    computed: {

        liberaRentab: function () {
            return (this.pedv.strentab == '1' && SysVars.usuarioAdministrador)
        },

        liberacaoEfetuada: function () {
            return (this.pedv.strentab == '3')
        },

        liberacaoReprovada: function () {
            return (this.pedv.strentab == '2')
        },

        desfazerLiberacao: function () {
            return SysVars.usuarioAdministrador && !this.pedv.data_leitura && this.pedv.tppedv == 'O'
        },

        hist: function () {
            let hist = JSON.parse(this.pedv.validation)
            if (hist && hist.historico_rentabilidade)
              return hist.historico_rentabilidade[hist.historico_rentabilidade.length -1]
            else
              return null
        },

    },

    mixins: [apiPedido],

    methods: {
        handleSave () {
            this.$emit('save')
        },

        handleLiberar (liberada, desfazerLiberacao) {
            this.apiRentab(this.pedv, liberada, desfazerLiberacao, this.obs, this.apiPedidoCallback)            
        },

        apiPedidoCallback () {
            this.$emit('reload')
        }


    },

    watch: {

    },

    components: {

    },

    created () {
    },

    mounted () {
    }

}

</script>

<template>
    <div>
        <div v-if="liberaRentab">
            <label-title title="Liberação de Orçamento" icon="fa-lock"></label-title>
            <alert type="warning" text="O pedido está aguardando liberação superior"></alert>
            <div class="row mb-2">
                <form-field v-model="obs" case="normal" type="memo" col="6" label="Observações"
                    name="obs" :v-errors="errors" v-validate="{}"></form-field>
            </div>
            <div class="row">
                <div class="col-12 d-flex">
                    <v-button label="Liberar Agora" :success="true" @click="handleLiberar(true)"></v-button>
                    <v-button label="Reprovar" @click="handleLiberar(false)"></v-button>
                </div>
            </div>
        </div>
        <div v-if="liberacaoEfetuada || liberacaoReprovada">
            <label-title v-if="liberacaoEfetuada" title="Rentabilidade" icon="fa-unlock"></label-title>
            <label-title v-if="liberacaoReprovada" title="Rentabilidade" icon="fa-lock"></label-title>
            <div class="row mb-2" v-if="hist">
                <div class="col-md-12 col-12 mb-2">
                    <span class="lbl-list pr-3"><i class="fa fa-calendar pr-2" aria-hidden="true"></i> Liberação efetuada em {{ this.hist.data | formatDataHoraExtenso }} </span>
                    <span class="lbl-list"><i class="fa fa-user pr-2"></i>Liberado por {{ hist.nome }} </span>
                </div>
                <div class="col-md-12 mb-2">
                    <span v-if="liberacaoEfetuada" class="badge badge-yellow mr-2" data-toggle="tooltip" data-placement="top" title="dataLeitura">Rentabilidade abaixo do mínimo liberada</span>
                    <span v-if="liberacaoReprovada" class="badge badge-red mr-2" data-toggle="tooltip" data-placement="top" title="dataLeitura">Rentabilidade reprovada</span>
                </div>
                <div class="col-md-12 col-12" v-if="hist.obs">
                    <div class="lbl">{{ hist.obs }}</div>
                </div>
            </div>
            <div class="row" v-if="desfazerLiberacao">
                <div class="col-12 d-flex">
                    <v-button label="Desfazer Liberação" @click="handleLiberar(false, true)"></v-button>
                </div>
            </div>
        </div>

    </div>

</template>


<style>

</style>



// WEBPACK FOOTER //
// src/forms/pedido-rentabilidade.vue